import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ErrorBoundary } from './components/error-boundary';
import { BASE_PATH } from './api/client';
import styles from './index.css?inline';

// The styles travel inside the script, not as a separate .css file: some corporate web filters block the stylesheet
// while passing the page and the script, which leaves every screen unformatted.
const styleElement = document.createElement('style');
styleElement.textContent = styles;
document.head.appendChild(styleElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale-while-revalidate by default — sensible for an assessment
      // tool where data changes infrequently within a session.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={BASE_PATH || '/'}>
        <AuthProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
